import * as React from 'react';
import { HierarchyToolTipFacet } from '../components/HierarchyToolTipFacet';
import { HierarchyEntity } from '../../Settings/data';
import { FacetLabel } from '../../util/types';
import { ParsedFacet } from './components/SearchFacets';


export const idHashFilter = (label: string, entity?: HierarchyEntity): FacetLabel => {
  const _label: string[] = label.split('#');
  if (_label.length !== 2) {
    return label;
  }
  const id: number = parseInt(_label[0], 10);
  const name: string = _label[1];
  if (entity === undefined || id < 1) {
    return name;
  }
  return <HierarchyToolTipFacet id={id} name={name} entity={entity}>{name}</HierarchyToolTipFacet>;
};

export const facetSortByLabelDesc = (a: ParsedFacet, b: ParsedFacet): number => {
  return a.key > b.key ? -1 : 1;
};

export const facetSortByLabelAsc = (a: ParsedFacet, b: ParsedFacet): number => {
  return a.key > b.key ? 1 : -1;
};

export const facetSortDefault = (a: ParsedFacet, b: ParsedFacet) => {
  if (a.factor === b.factor) return b.amount - a.amount;
  if (a.factor || b.factor === null) return -1;
  if (b.factor || a.factor === null) return 1;
  return 0;
};
